import Eventos from '@/evento/eventos.view.vue';
import AgregarEvento from '@/evento/agregar-evento.view.vue';
import DetalleEvento from '@/evento/detalle-evento.view.vue';
import ListaEventos from '@/evento/lista-eventos.view.vue';

export const eventos = {
  path: '/eventos',
  name: 'Eventos',
  component: Eventos,
  redirect: '/eventos/lista',
  children: [
    {
      path: 'agregar',

      name: 'AgregarEvento',
      component: AgregarEvento,
    },
    {
      path: ':id',

      name: 'DetalleEvento',
      component: DetalleEvento,
    },
    {
      path: 'lista',

      name: 'ListaEventos',
      component: ListaEventos,
    },
  ],
};
